module.exports = __webpack_public_path__ + "img/gallery-thumbnails.480ac8d6.svg";